import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';

interface chapitre {
  chapitre_name: string;
  start_time?: number;
  end_time?: number;
  Correct_start_time?: number;
  Correct_end_time?: number;
  Correct_chapitre_name?: string;
}

interface VideoLink {
  ID: string;
  Lien: string;
  State: string;
}

const intro_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Intro.png`; 
const caresse_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Petting.png`; 
const sixNine_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_69.png`; 
const andromaque_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Gemini.png`;
const bateauIvre_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Captain.png`;
const branletteEspagnole_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Titjob.png`;
const cowgirl_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Cowgirl.png`;
const chaiseBascule_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Reverse Cowgirl.png`;
const anulingus_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Rimjob.png`;
const ejaculation_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Cumshot.png`;
const cunnilingus_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Pussy Licking.png`;
const hommeDebout_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Barbell.png`;
const levrette_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Doggystyle.png`;
const levretteDebout_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Standing Doggystyle.png`;
const masturbation_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Masturbation.png`;
const leClou_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Piledriver.png`;
const petiteCuilleres_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Spoon.png`;
const pipe_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Blowjob.png`;
const unionElephant_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Boat.png`;
const missionary_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Missionary.png`;
const missionaryDebout_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Keeper.png`;
const eagle_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Eagle.png`;
const grasshopper_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Grasshopper.png`;
const hommePorte_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Column.png`;
const slowDance_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Slow Dance.png`;
const vis_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Screw.png`;
const placeConfort_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Comfortable Place.png`;

const chapterIcons: { name: string; src: string }[] = [
  {name: 'Intro', src: intro_Icon},
  {name: 'Petting', src: caresse_Icon},
  {name: '69', src: sixNine_Icon},
  {name: 'Gemini', src: andromaque_Icon},
  {name: 'Captain', src: bateauIvre_Icon},
  {name: 'Titjob', src: branletteEspagnole_Icon},
  {name: 'Cowgirl', src: cowgirl_Icon},
  {name: 'Reverse Cowgirl', src: chaiseBascule_Icon},
  {name: 'Rimjob', src: anulingus_Icon},
  {name: 'Cumshot', src: ejaculation_Icon},
  {name: 'Pussy Licking', src: cunnilingus_Icon},
  {name: 'Barbell', src: hommeDebout_Icon},
  {name: 'Doggystyle', src: levrette_Icon},
  {name: 'Standing Doggystyle', src: levretteDebout_Icon},
  {name: 'Masturbation', src: masturbation_Icon},
  {name: 'Piledriver', src: leClou_Icon},
  {name: 'Spoon', src: petiteCuilleres_Icon},
  {name: 'Blowjob', src: pipe_Icon},
  {name: 'Boat', src: unionElephant_Icon},
  {name: 'Missionary', src: missionary_Icon},
  {name: 'Keeper', src: missionaryDebout_Icon},
  {name: 'Eagle', src: eagle_Icon},
  {name: 'Grasshopper', src: grasshopper_Icon},
  {name: 'Column', src: hommePorte_Icon},
  {name: 'Slow Dance', src: slowDance_Icon},
  {name: 'Screw', src: vis_Icon},
  {name: 'Comfortable Place', src: placeConfort_Icon},
];

const AdminPage = () => {
  const baseVideoRef = useRef<HTMLVideoElement | null>(null);
  const correctedVideoRef = useRef<HTMLVideoElement | null>(null);

  const [videosLinks, setVideosLinks] = useState<VideoLink[]>([]);
  const [index, setIndex] = useState<number>(0);

  const [chapters, setChapters] = useState<chapitre[]>([]);
  const [indexChapitre, setIndexChapitre] = useState<number>(0);

  const [validationBase, setValidationBase] = useState<'none' | 'validate'>('none');
  const [validationCorrected, setValidationCorrected] = useState<'none' | 'validate'>('none');
  const [adminCorrection, setAdminCorrection] = useState<'none' | 'validate'>('none');

  const plageStart = localStorage.getItem('plageStart');
  const plageEnd = localStorage.getItem('plageEnd');

  const [adminStart, setAdminStart] = useState<number | null>(null);
  const [adminEnd, setAdminEnd] = useState<number | null>(null);
  const [adminName, setAdminName] = useState<string | null>(null);
  const [chapterCorrections, setChapterCorrections] = useState<any[]>([]);

  useEffect(() => {
    const fetchVideos = async () => {
      if (!plageStart || !plageEnd) return;
      try {
        const response = await axios.get(`https://foodybrain.com/api/ANTIMUS/get_admin_videos`, {
          params: { plageStart, plageEnd },
        });
        setVideosLinks(response.data);
      } catch (error) {
        console.error('Error API :', error);
      }
    };
    fetchVideos();
  }, [plageStart, plageEnd]);

  useEffect(() => {
    const fetchChapitres = async () => {
      if (!videosLinks[index]) return;
      try {
        const response = await axios.get(`https://foodybrain.com/api/ANTIMUS/get_video_chapitres`, {
          params: { id_video: videosLinks[index].ID },
        });
        const data = response.data.map((chap: chapitre) => ({
          ...chap,
          start_time: chap.start_time ?? 0,
          Correct_start_time: chap.Correct_start_time ?? 0,
        }));
        setChapters(data);
        setIndexChapitre(0);
        resetValidation();
      } catch (error) {
        console.error('Error API :', error);
      }
    };
    fetchChapitres();
  }, [videosLinks, index]);

  const resetValidation = () => {
    setValidationBase('none');
    setValidationCorrected('none');
    setAdminCorrection('none');
    setAdminStart(null);
    setAdminEnd(null);
    setAdminName(null);
  };

  const handleEditTime = (type: string, nb: number, ref: React.RefObject<HTMLVideoElement>) => {
    if (ref.current) {
      const current = Math.floor(ref.current.currentTime);
      ref.current.currentTime = type === 'plus' ? current + nb : Math.max(0, current - nb);
    }
  };
  
  const handleStartChapter = (ref: React.RefObject<HTMLVideoElement>, startTime?: number) => {
    if (ref.current && startTime !== undefined) ref.current.currentTime = startTime;
  };
  
  const handleEndChapter = (ref: React.RefObject<HTMLVideoElement>, endTime?: number) => {
    if (ref.current && endTime !== undefined) ref.current.currentTime = endTime;
  };

  const handleValidation = (type: 'base' | 'corrected' | 'admin') => {
    resetValidation();
    setValidationBase(type === 'base' ? 'validate' : 'none');
    setValidationCorrected(type === 'corrected' ? 'validate' : 'none');
    setAdminCorrection(type === 'admin' ? 'validate' : 'none');
  };

  const handleNext = async () => {
    let currentCorrection = null;
  
    if (adminCorrection === 'validate') {
      currentCorrection = {
        chapitre_name: adminName,
        start_time: adminStart,
        end_time: adminEnd,
      };
    } else if (validationCorrected === 'validate') {
      currentCorrection = {
        chapitre_name: chapters[indexChapitre]?.Correct_chapitre_name,
        start_time: chapters[indexChapitre]?.Correct_start_time,
        end_time: chapters[indexChapitre]?.Correct_end_time,
      };
    } else {
      currentCorrection = {
        chapitre_name: chapters[indexChapitre]?.chapitre_name,
        start_time: chapters[indexChapitre]?.start_time,
        end_time: chapters[indexChapitre]?.end_time,
      };
    }
  
    const updatedCorrections = [...chapterCorrections];
    updatedCorrections[indexChapitre] = currentCorrection;
    setChapterCorrections(updatedCorrections);
  
    if (indexChapitre + 1 < chapters.length) {
      setIndexChapitre(indexChapitre + 1);
    } else {
      try {
        await axios.post(`https://foodybrain.com/api/ANTIMUS/admin_correct_video_chapitres`, {
          id_video: videosLinks[index].ID,
          corrected_chapitres: updatedCorrections
        });
      } catch (error) {
        console.error('Error API :', error);
      }
  
      setChapterCorrections([]);
      setIndexChapitre(0);
      setIndex(index + 1);
    }
  
    resetValidation();
  };

  const isNextEnabled =
  validationBase === 'validate' ||
  validationCorrected === 'validate' ||
  (adminCorrection === 'validate' && adminName && adminStart !== null && adminEnd !== null);

  // Fonction pour gérer la sauvegarde des chapitres
const flagVideo = async (idVideo: string, commentaire: string) => {
    let APIcomment;
    if(commentaire === '') {
      APIcomment = "Regular Flag Comment"
    } else {
      APIcomment = commentaire;
    }
  
    if (idVideo === '') {
      alert('Problem to flag the video. Please contact the admin.');
      return;
    }
  
    try {
      // Appel à l'API pour sauvegarder les chapitres
      const response = await axios.post('https://foodybrain.com/api/ANTIMUS/flag_video', {
        id_video: idVideo,
        comment: APIcomment
      });
  
      alert('Video flag successfully !');
    } catch (error) {
      console.error('Flag error :', error);
      alert('Flag error. Please contact the admin.');
    }
  };
  
  const [flagComment, setFlagComment] = useState<string>("");
  
  const handleFlagButton = () => {
      flagVideo(videosLinks[index].ID, flagComment);
      setFlagComment("");
      resetValidation();
  
      const newIndex = index+1;
      setIndex(newIndex);
  };

  return (
    <div style={{ padding: '20px', backgroundColor: '#f0f0f0', minHeight: '100vh' }}>
      <h1 style={{ fontSize: '24px', textAlign: 'center', marginBottom: '20px' }}>Admin Check Chapitre</h1>

      {videosLinks.length > 0 && videosLinks.length > index && chapters.length > 0 ? (
          <>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '10px' }}>
            <label htmlFor="flag-comment" style={{ marginRight: '5px' }}>Flag Comment:</label>
              <textarea
                id="flag-comment"
                value={flagComment}  // État pour stocker la valeur du commentaire
                onChange={(e) => setFlagComment(e.target.value)}  // Mettre à jour l'état lors de la saisie
                placeholder="Enter your comment here"
                style={{
                  width: '500px',
                  height: '50px',
                  padding: '10px',
                  fontSize: '14px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                }}
              />
              <button
              onClick={handleFlagButton}
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                borderRadius: '5px',
                backgroundColor: '#ff3d3d',
                color: 'white',
                border: 'none',
                cursor: videosLinks[index] ? 'pointer' : 'not-allowed', // Changer le curseur si désactivé
                opacity: videosLinks[index] ? 1 : 0.6  // Rendre le bouton plus transparent s'il est désactivé
              }}
              disabled={!videosLinks[index]}
            >
              Flag the video
            </button>
          </div>

          <h2 style={{ textAlign: 'center' }}>
            Vidéo ID n°{videosLinks[index].ID} - Chapter {indexChapitre + 1}/{chapters.length}
          </h2>

          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px' }}>
            {/* Partie BASE */}
            <div style={{ width: '48%', textAlign: 'center' }}>
              <h3>Timestamp Version</h3>
              <video ref={baseVideoRef} controls width="100%">
                <source src={`https://foodybrain.com/videos/video_${videosLinks[index].ID}.mp4`} type="video/mp4" />
              </video>
              <p><strong>Chapter:</strong> {chapters[indexChapitre]?.chapitre_name}</p>
              {chapterIcons.find(i => i.name === chapters[indexChapitre]?.chapitre_name) && (
                <img src={chapterIcons.find(i => i.name === chapters[indexChapitre]?.chapitre_name)!.src} style={{ height: '100px' }} />
              )}
              <p>Start: {chapters[indexChapitre]?.start_time}s | End: {chapters[indexChapitre]?.end_time}s</p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '5%', flexWrap: 'wrap' }}>
                <button onClick={() => handleEditTime("moins", 1, baseVideoRef)}>-1 sec</button>
                <button onClick={() => handleEditTime("plus", 1, baseVideoRef)}>+1 sec</button>
                <button onClick={() => handleStartChapter(baseVideoRef, chapters[indexChapitre]?.start_time)}>Start Chapter</button>
                <button onClick={() => handleEndChapter(baseVideoRef, chapters[indexChapitre]?.end_time)}>End Chapter</button>
              </div>
            </div>

            {/* Partie CORRECTION */}
            <div style={{ width: '48%', textAlign: 'center' }}>
              <h3>Correction Version</h3>
              <video ref={correctedVideoRef} controls width="100%">
                <source src={`https://foodybrain.com/videos/video_${videosLinks[index].ID}.mp4`} type="video/mp4" />
              </video>
              <p><strong>Chapter:</strong> {chapters[indexChapitre]?.Correct_chapitre_name}</p>
              {chapterIcons.find(i => i.name === chapters[indexChapitre]?.chapitre_name) && (
                <img src={chapterIcons.find(i => i.name === chapters[indexChapitre]?.chapitre_name)!.src} style={{ height: '100px' }} />
              )}
              <p>Start: {chapters[indexChapitre]?.Correct_start_time}s | End: {chapters[indexChapitre]?.Correct_end_time}s</p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '5%', flexWrap: 'wrap' }}>
                <button onClick={() => handleEditTime("moins", 1, correctedVideoRef)}>-1 sec</button>
                <button onClick={() => handleEditTime("plus", 1, correctedVideoRef)}>+1 sec</button>
                <button onClick={() => handleStartChapter(correctedVideoRef, chapters[indexChapitre]?.Correct_start_time)}>Start Chapter</button>
                <button onClick={() => handleEndChapter(correctedVideoRef, chapters[indexChapitre]?.Correct_end_time)}>End Chapter</button>
              </div>
            </div>
          </div>

          {/* Boutons de validation */}
          <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
            <button onClick={() => handleValidation('base')} style={{ backgroundColor: validationBase === 'validate' ? 'green' : 'lightgray', padding: '10px' }}>
              Validation Timestamp
            </button>
            <button onClick={() => handleValidation('corrected')} style={{ backgroundColor: validationCorrected === 'validate' ? 'green' : 'lightgray', padding: '10px' }}>
              Validation Correction
            </button>
            <button onClick={() => handleValidation('admin')} style={{ backgroundColor: adminCorrection === 'validate' ? 'green' : 'lightgray', padding: '10px' }}>
              Admin Correction
            </button>
          </div>

          {/* Admin Form */}
          {adminCorrection === 'validate' && (
            <div style={{ marginTop: '20px', background: '#fff', padding: '15px', borderRadius: '5px' }}>
                <h3>Admin Correction</h3>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '10px' }}>
                    <input
                        type="number"
                        placeholder="Admin Start Time"
                        value={adminStart ?? ''}
                        onChange={(e) => setAdminStart(parseInt(e.target.value))}
                    />
                    <input
                        type="number"
                        placeholder="Admin End Time"
                        value={adminEnd ?? ''}
                        onChange={(e) => setAdminEnd(parseInt(e.target.value))}
                    />
                </div>
                <div>
                    <h4>Admin Chapter</h4>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', justifyContent: 'center' }}>
                        {chapterIcons.map(({ name, src }) => (
                        <img
                            key={name}
                            src={src}
                            alt={name}
                            onClick={() => setAdminName(name)}
                            style={{
                            height: '100px',
                            border: adminName === name ? '4px solid green' : '2px solid transparent',
                            borderRadius: '8px',
                            cursor: 'pointer'
                            }}
                        />
                        ))}
                    </div>
                </div>
            </div>
          )}

          {/* Bouton suivant */}
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }}>
            <button
                onClick={handleNext}
                disabled={!isNextEnabled}
                style={{
                    marginTop: '30px',
                    padding: '10px 20px',
                    fontSize: '16px',
                    backgroundColor: isNextEnabled ? '#007bff' : '#ccc',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: isNextEnabled ? 'pointer' : 'not-allowed'
                }}
                >
                Next Admin Video
            </button>
          </div>
        </>
      ) : (
        <p style={{ textAlign: 'center' }}>You have finished the fnal check of your range of video.</p>
      )}
    </div>
  );
};

export default AdminPage;
